(ns practitest.frontend.components.datepicker
  (:require [tick.core :as tick]
            [clojure.string :as str]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.subs :as subs]
            [re-frame.core :as re-frame]))

;; Does not support seconds in datetime-local
(def datetime-local-formatter (tick/formatter "yyyy-MM-dd'T'HH:mm"))

(defn- find-datetime-input
  "Find datetime input element by trying multiple strategies:
   1. Direct ref (fastest)
   2. DOM getElementById (for components with IDs like ET)
   3. DOM traversal from event target (for Angular Grid filters)"
  [input-ref field-id event]
  (or @input-ref
      (when field-id
        (js/document.getElementById (str field-id)))
      (when-let [target (.-currentTarget event)]
        (when-let [parent (.-parentElement target)]
          (.querySelector parent "input[type='datetime-local']")))))

(defn- format-instant-for-display
  "Format instant in user's timezone for datetime-local input display"
  [instant-value user-timezone]
  (if user-timezone
    (let [zone (tick/zone user-timezone)
          zoned-dt (tick/in instant-value zone)]
      (tick/format datetime-local-formatter zoned-dt))
    ;; Fallback to browser timezone if no user timezone
    (tick/format datetime-local-formatter (tick/date-time instant-value))))

(defn instant-picker
  [{:keys [on-change
           class
           field-id
           value
           disabled?]
    :as   props}]
  (let [input-ref (atom nil)
        user-timezone @(re-frame/subscribe [::subs/current-user-timezone])
        ;; Handle timezone offsets like "2024-03-01T04:00:00+02:00"
        instant-value (when value
                        (if (tick/instant? value)
                          value
                          (let [trimmed (str/trim (str value))]
                            (when-not (str/blank? trimmed)
                              (if (re-find #"[+-]\d{2}:\d{2}$" trimmed)
                                ;; Has timezone offset - parse as zoned-date-time first
                                (tick/instant (tick/zoned-date-time trimmed))
                                ;; No timezone offset - parse as instant
                                (tick/instant trimmed))))))
        ;; Convert instant to user's timezone for display
        value* (when instant-value
                 (format-instant-for-display instant-value user-timezone))]
    [:div.datepicker-input-holder
     [:input
      {:class     class
       :type      "datetime-local"
       :id        field-id
       :ref       #(reset! input-ref %)
       :value     value*
       :disabled  disabled?
       :on-change (when on-change
                    (fn [e]
                      (let [datestr (dom/event-value e)
                            ;; Parse datetime-local in user's timezone (fallback to browser timezone)
                            instant (when-not (str/blank? datestr)
                                      (let [local-dt (tick/date-time datestr)]
                                        (if user-timezone
                                          (-> local-dt (.atZone (tick/zone user-timezone)) tick/instant)
                                          (tick/instant local-dt))))]
                        (on-change instant))))}]
     [:span.datepicker-input-icon
      {:on-click (fn [e]
                   (when-let [input (find-datetime-input input-ref field-id e)]
                     (if-let [show-picker (aget input "showPicker")]
                       ;; Modern browsers - open native picker with showPicker API
                       (try
                         (.call show-picker input)
                         (catch js/Error _
                           ;; Fallback if showPicker throws
                           (.click input)))
                       ;; Older browsers - simulate click
                       (.click input))))}
      [icons/mux-calendar-manual]]]))

(defn time-picker
  [{:keys [on-change
           class
           field-id
           value
           disabled?]
    :as   props}]
  (let [formatter (tick/formatter :iso-local-time)
        value* (if (tick/time? value)
                 (tick/format formatter value)
                 value)]
    [:input
     {:class     class
      :type      "time"
      :id        field-id
      :value     value*
      :disabled  disabled?
      :on-change (fn [e]
                   (let [timestr (dom/event-value e)
                         ;; uses current browser timezone by default
                         time (when-not (str/blank? timestr)
                                (tick/time timestr))]
                     (when on-change
                       (on-change time))))}]))
